import React, { useMemo } from "react";
import { Button, Stack } from "@mui/material";
import { PROFIT_MODE, ProfitMode } from "./types";
import { LoadingButton } from "@mui/lab";

type Props = {
  activeTab: ProfitMode;
  shouldShowOverriddenTab: boolean;
  shouldShowActualTab: boolean; // ✅ NEW
  translateWithoutPrefix: (_key: string) => string;
  editMode: boolean;
  setEditMode: React.Dispatch<React.SetStateAction<boolean>>;
  onSave: () => void;
  onCancel: () => void;
  isDirty: boolean;
  isSaving: boolean;
};

export const useOrderProfitHeader = ({
  activeTab,
  shouldShowOverriddenTab,
  shouldShowActualTab,
  translateWithoutPrefix,
  editMode,
  setEditMode,
  onSave,
  onCancel,
  isDirty,
  isSaving,
}: Props) => {
  // ✅ edit yapılabilir mi?
  const hasEditableTab = shouldShowOverriddenTab || shouldShowActualTab;

  const editTabPath = useMemo(() => {
    if (shouldShowOverriddenTab) return PROFIT_MODE.OVERRIDDEN;
    if (shouldShowActualTab) return PROFIT_MODE.ACTUAL;
    return null;
  }, [shouldShowOverriddenTab, shouldShowActualTab]);

  const isEditableTab = activeTab === editTabPath;

  const headerActions = useMemo(() => {
    // ❌ hiçbir editable tab yok → hiçbir şey render etme
    if (!hasEditableTab) return undefined;

    // ❌ editable ama bu tab değil → yine gösterme
    if (!isEditableTab) return undefined;

    if (!editMode) {
      return (
        <Button
          size="small"
          variant="outlined"
          onClick={() => setEditMode(true)}
        >
          {translateWithoutPrefix("buttons.edit")}
        </Button>
      );
    }

    return (
      <Stack direction="row" spacing={1}>
        <LoadingButton
          size="small"
          variant="contained"
          onClick={onSave}
          disabled={!isDirty || isSaving}
          loading={isSaving}
        >
          {translateWithoutPrefix("buttons.save")}
        </LoadingButton>

        <Button size="small" variant="outlined" onClick={onCancel}>
          {translateWithoutPrefix("buttons.cancel")}
        </Button>
      </Stack>
    );
  }, [
    hasEditableTab,
    isEditableTab,
    editMode,
    setEditMode,
    translateWithoutPrefix,
    onSave,
    onCancel,
    isDirty,
    isSaving,
  ]);

  return { headerActions };
};
